import script from "./MailInternal.vue?vue&type=script&setup=true&lang=js"
export * from "./MailInternal.vue?vue&type=script&setup=true&lang=js"

import "./MailInternal.vue?vue&type=style&index=0&id=854c918e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854c918e"]])

export default __exports__